module.exports = __webpack_public_path__ + "static/product_header_right-1fdf417f983cb75cd99fbb40d8896474.png";